import { render } from "./ArticlesComponent.vue?vue&type=template&id=1ca8c601"
import script from "./ArticlesComponent.vue?vue&type=script&lang=js"
export * from "./ArticlesComponent.vue?vue&type=script&lang=js"

import "./ArticlesComponent.vue?vue&type=style&index=0&id=1ca8c601&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__